import { InvokeCallback, Sender } from "xstate";
import { portfolioPositionsId } from "@rentablo/api/apiv1";
import { withToken } from "@rentablo/api";
import { DividendWizardContext } from "../types/dividendWizardContext";
import { DividendWizardEvent } from "../types/dividendWizardEvent";

export const loadBooking =
  (
    context: DividendWizardContext,
    event: DividendWizardEvent
  ): InvokeCallback<DividendWizardEvent, DividendWizardEvent> =>
  (callback: Sender<DividendWizardEvent>) => {
    if (event.type !== "LOADED_INVESTMENT") {
      throw new Error(`Invalid event type ${event.type}`);
    }

    if (!context.bookingId) {
      throw new Error(`Invalid booking id: ${context.bookingId}`);
    }

    load(context.bookingId, callback);
  };

const load = async (
  bookingId: number,
  callback: Sender<DividendWizardEvent>
) => {
  try {
    const booking = await withToken(portfolioPositionsId)({ id: bookingId });

    callback({
      type: "LOADED_BOOKING",
      booking,
    });
  } catch (e) {
    callback({
      type: "SOMETHING_WRONG",
      error: e as AxiosApiError,
    });
  }
};
